import clone from 'clone'
import http from '@/utils/ajax'
import { RTNTYPE_INIT_LOADING, RTNTYPE_INIT_SUCCESS, RTNTYPE_INIT_FAIL } from '@/store/types'
import { extractMenu, extractMessages } from '@/utils/extract'

export const initialState = {
  // 0: Loading, 1: Success, 2: Fail
  init: 0,
  initErr: [],
  menu: {}
}

const getters = {

}

const mutations = {
  [RTNTYPE_INIT_LOADING](state, err) {
    state.init = 0
    state.initErr = []
    state.menu = {}
  },
  [RTNTYPE_INIT_SUCCESS](state, data) {
    state.init = 1
    state.initErr = []
    state.menu = data.menu
  },
  [RTNTYPE_INIT_FAIL](state, err) {
    state.init = 2
    state.initErr = err
    state.menu = {}
  }
}

const actions = {
  async rtnTypeManagementInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.rtnTypeManagement
    commit(RTNTYPE_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(RTNTYPE_INIT_SUCCESS, commitResult)
    } catch (err) {
      commit(RTNTYPE_INIT_FAIL, extractMessages(err))
    }
  }
}

export default {
  state: clone(initialState),
  getters,
  mutations,
  actions
}
